import React from "react";
import Owlbert from "@/components/Owlbert";

/**
 * <LinkedInLabBrand /> — canonical wordmark + mascot pair.
 * Use on login, client portal top-bar, empty states, footers.
 *
 * variant: "full" (owl + wordmark + tagline)
 *          "compact" (owl + wordmark)
 *          "wordmark" (text only)
 */
export default function LinkedInLabBrand({
  variant = "compact",
  mood = "cheer",
  size = "md",
  onDark = false,
  className = "",
}) {
  const inkPrimary = onDark ? "#ffffff" : "#111827";
  const inkSecondary = onDark ? "rgba(255,255,255,0.7)" : "#6b7280";
  const owlSize =
    size === "xs" ? "xs" : size === "sm" ? "sm" : size === "lg" ? "lg" : size === "xl" ? "xl" : "md";
  const wordSize =
    size === "xs" ? "text-xs" : size === "sm" ? "text-sm" : size === "lg" ? "text-lg" : size === "xl" ? "text-2xl" : "text-base";
  const tagSize = size === "xl" || size === "lg" ? "text-[11px]" : "text-[10px]";

  return (
    <div className={`inline-flex items-center gap-2.5 ${className}`} data-testid="linkedin-lab-brand">
      <Owlbert mood={mood} size={owlSize} />
      {variant !== "wordmark-only" && (
        <div className="min-w-0">
          <div
            className={`${wordSize} font-semibold leading-none tracking-tight`}
            style={{ fontFamily: "Manrope, sans-serif", color: inkPrimary }}
          >
            LinkedIn Lab
          </div>
          {variant === "full" && (
            <div
              className={`${tagSize} mt-1 font-medium tracking-[0.18em] uppercase`}
              style={{ color: inkSecondary }}
            >
              Content · Engagement
            </div>
          )}
        </div>
      )}
    </div>
  );
}
